/**
 * Created by Administrator.
 */
import axios from 'axios';
import router from '@/router/index';
import { getDeviceTimeZone, getDisplayTimeZone, normalizeApiTimes } from './timezone';
// 设置请求超时的时间
// axios.defaults.timeout = 300000; //300000
// 设置访问的域名前缀
// axios.defaults.baseURL = 'https://uudex.com/wapi/';

const daRequest = axios.create({
  baseURL: 'https://uudex.com/wapi/',
  timeout: 300000,
});
daRequest.defaults.timeout = 300000;
// http request 拦截器
daRequest.interceptors.request.use(
  (config) => {
    config.data = config.data;
    config.headers.client = 'pc';
    config.headers.version = '20260804';
    config.headers['X-Device-Timezone'] = getDeviceTimeZone();
    if (config.data && config.data.q_package && !config.data.q_package.pickup_timezone) {
      config.data.q_package.pickup_timezone = getDisplayTimeZone(config.data);
    }
    if (config.data && config.data.goods_info && config.data.goods_info.shipment_date && !config.data.goods_info.shipment_timezone) {
      config.data.goods_info.shipment_timezone = getDisplayTimeZone(config.data);
    }
    // 设置请求头
    // config.headers = {
    //   'Content-Type': 'application/x-www-form-urlencoded',
    //   // "content-type": "application/json;charset=UTF-8"
    // };
    // if(token){
    //   config.params = {'token':token}
    // }
    return config;
  },
  (error) => {
    Promise.reject(error);
  },
);

// http response 拦截器
daRequest.interceptors.response.use(
  (response) => {
    if (response.data && response.data.data) normalizeApiTimes(response.data.data);
    if (response.data.code === 401) {
      window.localStorage.removeItem('userInfo1');
      router.replace({
        path: '/login',
        query: { redirect: router.currentRoute.fullPath }, // 从哪个页面跳转
      });
    }
    return response;
  },
  (error) => {
    const data = error.response && error.response.data ? error.response.data : null;
    if (data && data.code === 401) {
      window.localStorage.removeItem('userInfo1');
      router.replace({
        path: '/login',
        query: { redirect: router.currentRoute.fullPath }, // 从哪个页面跳转
      });
    }
    return Promise.reject(data || error);
  },
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    daRequest.get(url, {
      params,
    })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
// json格式的数据封装
export function postj(url, data = {}) {
  return new Promise((resolve, reject) => {
    daRequest.post(url, data, {
      headers: {
        "content-type": "application/json;charset=UTF-8"
      }
    })
      .then((response) => {
        resolve(response.data);
      }, (err) => {
        reject(err);
      });
  });
}

// 键值对数据格式封装
export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    // 使用URLSearchParams来序列化数据
    let postData = new URLSearchParams();
    for (let key in data) {
      postData.append(key, data[key]);
    }
    // 发送请求，设置Content-Type为application/x-www-form-urlencoded
    daRequest.post(url, postData, {
      headers: {
          "Content-Type": "application/x-www-form-urlencoded"
      }
    })
    .then(response => {
      resolve(response.data);
    })
    .catch(err => {
      reject(err);
    });
  });
}

export function postfd(url, data) {
  return new Promise((resolve, reject) => {
    daRequest.post(url, data)  
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}
